import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/what_traders_say/logo-trustpilot.svg")